import styled, { css } from 'styled-components';

/**
 * Host for the Select popup. The dropdown is portaled here (not to document.body)
 * and forced into normal document flow so it expands the filter above OK/Reset
 * instead of overlaying them.
 */
export const OptionsSlot = styled.div`
  position: relative;
  width: 100%;

  .ant-select-dropdown {
    position: static !important;
    inset: auto !important;
    width: 100% !important;
    min-width: 0 !important;
    margin-top: 4px;
    box-shadow: none;
    border: 1px solid ${({ theme }) => theme.borderColor};
    border-radius: 2px;
  }

  .ant-select-dropdown-hidden {
    display: none !important;
  }

  .rc-virtual-list-holder,
  .ant-select-dropdown .rc-virtual-list {
    max-height: var(--table-filter-multi-select-list-height, 200px) !important;
  }
`;

export const TableFilterMultiSelectRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > .ant-select {
    width: 100%;
  }
`;

/**
 * Wider clickable search area + permanent search icon left of clear (X) — Mac UX
 * so X alone is not the only hit target in the selector.
 */
export const multiSelectWiderClickableAreaStyles = css`
  .ant-select-selector {
    padding-inline-end: 56px !important;
  }

  .ant-select-clear {
    inset-inline-end: 11px;
  }

  .ant-select-suffix {
    inset-inline-end: 30px;
    pointer-events: none;
  }
`;

/** Keeps the selector wide enough for its search and clear controls. */
export const FilterMultiSelectContainer = styled.div`
  width: 260px;

  ${multiSelectWiderClickableAreaStyles}
`;
